<template>
  <b-modal
    ref="modal"
    class="vas-unsub-modal-component"
    centered
    no-close-on-backdrop
    hide-header
    hide-footer
    :visible="isUnsubscribing"
    modal-class="bg-light"
    @hidden="cancel"
  >
    <article
      v-if="isShowingUnsub"
      class="d-flex flex-column align-items-center justify-content-between h-100 px-3"
    >
      <header class="w-100 text-danger pt-5">
        <h2>{{ $t('security.unsubModal.title') }}</h2>
      </header>

      <p class="unsub-text w-100 py-2" v-html="unsubConfigMessages.unsubText" />
      <b-button variant="danger" size="lg" block @click="confirm">
        {{ $t('security.unsubModal.unsubButtonText') }}
      </b-button>
      <b-link class="d-sm-none d-xxs-flex align-self-start" to="/TermsAndConditions">
        {{ $t('security.termsAndConditions') }}
      </b-link>

      <footer class="d-flex flex-column w-100 pt-4">
        <div class="line mb-4" />
        <b-link class="d-flex pb-2 align-self-end" @click="close">
          {{ $t('security.backToHomePage') }}
        </b-link>
      </footer>
    </article>

    <article v-if="isShowingUnsubConfirm" class="align-items-center pt-4 px-2">
      <strong class="d-flex h2 text-dark py-2">
        {{ $t('security.unsubModal.confirmText') }}
      </strong>
      <footer class="d-flex flex-xxs-column flex-sm-row justify-content-sm-end w-100 pt-4">
        <b-button variant="danger" size="lg" class="px-4 m-xxs-2 m-sm-0" @click="unSub">
          {{ $t('security.unsubModal.unsubButtonText') }}
        </b-button>
        <b-button variant="success" size="lg" class="px-4 mx-2" @click="cancel">
          {{ $t('security.unsubModal.cancelButtonText') }}
        </b-button>
      </footer>
    </article>

    <article v-if="isShowingOtp" class="align-items-center">
      <header class="py-2 w-100">
        <h2 class="text-danger">{{ $t('security.unsubModal.title') }}</h2>
      </header>
      <PinInput :pinLength="pinLength" ref="pinInput" />
      <span v-if="errorStatus" class="text-danger">{{ $t(errorStatus) }}</span>
      <div class="d-flex flex-xxs-column flex-sm-row justify-content-sm-end w-100 pt-4">
        <b-button
          :disabled="checkBtn"
          variant="success"
          class="w-50 ml-2 px-4"
          @click="checkPin"
        >
          {{ $t('security.confirmPinButtonText') }}
        </b-button>
      </div>
      <footer class="d-flex flex-column w-100 pt-4">
        <div class="line mb-4" />
        <b-link class="d-flex pb-2 align-self-end" @click="close">
          {{ $t('security.backToHomePage') }}
        </b-link>
      </footer>
    </article>

    <article v-if="isShowingSuccessfulUnsub" class="align-items-center">
      <header class="pt-xxs-4 pt-sm-5 px-xxs-1 px-sm-4 w-100">
        <h2 class="text-success">
          {{ $t('security.successfullUnsubModal.title') }}
        </h2>
      </header>

      <p class="pt-xxs-3 pt-sm-4 px-xxs-1 px-sm-4 success-unsub-desc" v-html="unsubConfigMessages.successfullUnsubDescription" />

      <footer class="d-flex flex-column w-100 pt-sm-4 pt-xxs-1">
        <p class="d-flex px-4 align-self-end">
          {{ $t('security.successfullUnsubModal.seeYou') }}
        </p>
        <b-link class="d-flex px-5 align-self-end" @click="close">
          {{ $t('security.successfullUnsubModal.tenantName',{tenantName:tenantConfig.name}) }}
        </b-link>
      </footer>
    </article>

    <section v-if="isShowingUnsub" class="unsub-bubble-information text-white p-5 d-sm-flex d-xxs-none">
      <p class="align-self-center mx-auto px-3" v-html="unsubConfigMessages.unsubInformation" />
    </section>

    <footer class="circles position-fixed d-sm-block d-xxs-none">
      <div class="circle green rounded-circle position-absolute" />
      <div class="circle yellow rounded-circle position-absolute" />
      <div class="circle blue rounded-circle position-absolute" />
      <div class="circle red rounded-circle position-absolute" />
    </footer>
    <SubscriptionLoading :is-loading="isloading" />
  </b-modal>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import utility from '@/utilities/utility'
import PinInput from '@/components/PinInput.vue'
import SubscriptionLoading from '@/components/SubscriptionLoading.vue'

export default Vue.extend({
  name: 'VasUnsubModal',
  components: {
    PinInput,
    SubscriptionLoading
  },
  data () {
    return {
      successfullResponse : null,
      isShowingUnsub: true,
      isShowingUnsubConfirm: false,
      isShowingOtp: false,
      isShowingSuccessfulUnsub: false,
      isloading: false,
      checkBtn: false,
      resendBtn: true,
      time: 30,
      errorStatus: null,
      pinLength: 6
    }
  },
  computed: {
    ...mapGetters({
      userProfile: 'auth/userProfile',
      tenantDesignConfig: 'tenantDesign/config',
      tenantConfig: 'tenantConfig/tenantInfo',
      userSubscriptions: 'subscription/userSubscriptions',

      isUnsubscribing: 'navigation/isUnsubscribing'
    }),
    unsubConfigMessages () {
      return this.tenantDesignConfig.pages.vasUnsub.configurations
    },
    tenantLoginType () {
      return this.tenantDesignConfig.userManagement.loginType.toLowerCase()
    },
    pinInput () {
      return this.$refs.pinInput
    },
    pin () {
      return this.pinInput.pin
    }
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      unsub: 'subscription/unsubscribe',
      confirmUnsub: 'subscription/confirmUnsubscribe',
      hideUnsub: 'navigation/hideUnsub'
    }),
    show () {
      this.$refs.modal.show()
    },
    close () {
      this.$refs.modal.hide()
      location.reload()
    },
    confirm () {
      this.isShowingUnsub = false
      this.isShowingUnsubConfirm = true
      this.isShowingOtp= false
      this.isShowingSuccessfulUnsub = false
      this.$refs.modal.modalClasses.push('confirm')
    },
    unSub () {
        this.isloading = true
        let payLoad = {
          deviceType: 'None',
          channel: 'Portal',
          userName: this.userProfile.username,
          planProviderCode: this.userSubscriptions[0].planProviderCode,
          channelName: 'portal'
        }
        if (this.tenantLoginType === 'organic') {
          if (this.userSubscriptions.length > 0) {
            payLoad.userName = this.userSubscriptions[0].userName
          }
        }
        this.unsub(payLoad).then(response => {
          if(response.body.result.unSubscriptionMethod === 'CG'){
             window.location.href = response.body.result.redirectUrl
          } else if (response.body.result.unSubscriptionMethod !== 'Api') {
            this.isShowingUnsub = false
            this.isShowingUnsubConfirm = false
            this.isShowingOtp= true
            this.isShowingSuccessfulUnsub = false
            this.isloading = false
            if (response.status === 200) {
              this.successfullResponse = response
            }
        } else {
          if (response.status === 200) {
             if (this.tenantLoginType === 'organic') {
               this.isShowingUnsub = false
               this.isShowingUnsubConfirm = false
               this.isShowingSuccessfulUnsub = true
               this.removeClass('confirm')
               this.$refs.modal.modalClasses.push('success')
               this.isloading = false
             } else {
               this.logout()
               this.isShowingUnsub = false
               this.isShowingUnsubConfirm = false
               this.isShowingSuccessfulUnsub = true
               this.removeClass('confirm')
               this.$refs.modal.modalClasses.push('success')
               this.isloading = false
            }
          }
        }
      })
    },
    checkPin(){
        this.isloading = true
      if(this.successfullResponse){
            let result = this.successfullResponse.body.result
            let confirmPayload = {
              RequesterServiceRefCode: result.code,
	            UserInput: this.pin
            }
            this.confirmUnsub(confirmPayload).then(confirmResponse => {
              if(confirmResponse.status === 200 && confirmResponse.body.result.status === 'Success'){
                if (this.tenantLoginType === 'organic') {
                 this.isShowingUnsub = false
                 this.isShowingUnsubConfirm = false
                 this.isShowingOtp= false
                 this.isShowingSuccessfulUnsub = true
                 this.removeClass('confirm')
                 this.$refs.modal.modalClasses.push('success')
                 localStorage.clear()
                 this.isloading = false
                } else {
                 this.logout()
                 this.isShowingUnsub = false
                 this.isShowingUnsubConfirm = false
                 this.isShowingOtp= false
                 this.isShowingSuccessfulUnsub = true
                 this.removeClass('confirm')
                 this.$refs.modal.modalClasses.push('success')
                 localStorage.clear()
                 this.isloading = false
                }
              } else {
                 let status = confirmResponse.body.result.status
                if(status === 'Failed'){
                  this.errorStatus = 'security.pinIsInvalid'
                }
                else if(status === 'MaxRetryReached'){
                  this.errorStatus = 'security.maxRetry'
                }
                else if(status === 'Expired'){
                  this.errorStatus = 'security.pinIsExpired'
                }
                 this.isloading = false
              }               
            })
          .catch(error => {
            if (error) {
              this.errorStatus = 'security.pinIsInvalid'
              this.isloading = false
            }
          })
      }
    },
    cancel () {
      this.isShowingUnsub = true
      this.isShowingOtp = false
      this.isShowingUnsubConfirm = false
      this.isShowingSuccessfulUnsub = false
      this.hideUnsub()
      this.removeClass('confirm')
      this.removeClass('success')
    },
    removeClass (className) {
      var modalClasses = this.$refs.modal.modalClasses
      var index = modalClasses.indexOf(className)
      if (index !== -1) {
        modalClasses.splice(index)
      }
    }
  }
})
</script>
